//
//
//
//
//
//
//

export default {
  name: "headDetails",
  props: {
  },
  computed: {
  },
  data: {
  },
  methods: {
  }
};



// WEBPACK FOOTER //
// ./src/components/headDetails.vue